module.exports = {
   stateLocations: {
        Analytics: {
            Base: "Analytics",
            Url: "Url",
        },
        Conversation: {
            isUserLoggedIn: "IsUserLoggedIn",
            receivedResponseWatches : [
                "Conversation.ReceivedResponse",
                "Conversation.UploadHistory.ReceivedResponse",
                "History.ReceivedResponse",
            ],
            stagedInputWatches: [
                "Conversation.UploadHistory.StagedInput",
                "History.StagedInput",
                "Window.Input.StageLocation",
                "Window.StagedEvent",
                "Conversation.DisplayLinks.StagedInput",
                "WelcomeUser.StagedEvent",
                "VersionReporter.StagedEvent",
                "AutoNav.StagedEvent",
            ],
        },
        FormInteraction:  {
            Base: "FormInteraction",
            EntryId: "EntryId",
        },
        PersistentStorage : {
            Base: "PersistentStorage",
            watches: {
                NITAlme: [
                    "CommandAction.PageLoadActions",
                    "Conversation.SessionId",
                    "Conversation.AccessKey",
                    "Conversation.UserId",
                    "Window.IsMinimized",
                    "Conversation.IsActiveSession",
                    "FormInteraction.entryId",
                    "Survey.visible",
                    "Survey.EntryId",
                ],
            },
        },
   },
   FooterLinks : [
        {
            DisplayText: "About Julie",
            TargetType: "unit",
            Metadata:{
                UnitUID: "060730c9-f137-4759-93d4-c359ec48ba9c",
            },
        },
    ],
    Window: {
        stagedEvent: "StagedEvent",
        currentTree: "CurrentTree",
    },
};


// WEBPACK FOOTER //
// ./settings/contact-us-page.js